import { render } from "./BadgeList.vue?vue&type=template&id=3874ba8f&scoped=true"
import script from "./BadgeList.vue?vue&type=script&lang=js"
export * from "./BadgeList.vue?vue&type=script&lang=js"

import "./BadgeList.vue?vue&type=style&index=0&id=3874ba8f&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3874ba8f"]])

export default __exports__